'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'accountNumber';
exports.ACCOUNT_NUMBER_ERROR = void 0;
(function(ACCOUNT_NUMBER_ERROR) {
    ACCOUNT_NUMBER_ERROR["US"] = "accountNumber.us";
    ACCOUNT_NUMBER_ERROR["CA"] = "accountNumber.ca";
    ACCOUNT_NUMBER_ERROR["OTHER"] = "accountNumber.other";
})(exports.ACCOUNT_NUMBER_ERROR || (exports.ACCOUNT_NUMBER_ERROR = {}));
y__namespace.addMethod(y__namespace.StringSchema, name, function({ variant, usError = exports.ACCOUNT_NUMBER_ERROR.US, caError = exports.ACCOUNT_NUMBER_ERROR.CA, otherError = exports.ACCOUNT_NUMBER_ERROR.OTHER }) {
    const getKey = ()=>{
        switch(variant){
            case 'us':
                return usError;
            case 'ca':
                return caError;
            case 'other':
                return otherError;
        }
    };
    return this.test({
        name,
        message: {
            key: getKey()
        },
        test: (value)=>{
            if (!value) return false;
            switch(variant){
                case 'us':
                    return /^[a-zA-Z0-9]{6,35}$/.test(value);
                case 'ca':
                    return /^\d{7,12}$/.test(value);
                case 'other':
                    return /^[a-zA-Z0-9]{6,35}$/.test(value);
            }
        }
    });
});
//# sourceMappingURL=accountNumber.js.map
